import React from 'react';
import { TextProps } from '.';
import { H1_TITLE, H2_TITLE, H3_TITLE, H4_TITLE, H5_TITLE } from './titles';

type titleTypes = 'h1' | 'h2' | 'h3' | 'h4' | 'h5';

export interface TitleProps extends TextProps {
    component?: titleTypes;
    children?: React.ReactNode;
}

export const Title: React.FC<TitleProps> = React.memo(
    ({ component, children, ...props }) =>
        component === 'h5' ? (
            <H5_TITLE {...props}>{children}</H5_TITLE>
        ) : component === 'h4' ? (
            <H4_TITLE {...props}>{children}</H4_TITLE>
        ) : component === 'h3' ? (
            <H3_TITLE {...props}>{children}</H3_TITLE>
        ) : component === 'h2' ? (
            <H2_TITLE {...props}>{children}</H2_TITLE>
        ) : (
            <H1_TITLE {...props}>{children}</H1_TITLE>
        )
);
